import { Reference } from 'pages/StudyList/StudyList';
import { Document } from 'types';

export type ReferenceMinimal = Pick<
  Reference,
  'id' | 'title' | 'url' | 'document_url'
>;

export type TransformedFile = {
  id: number | string | null;
  url: string | null;
  file?: File;
  uploadComplete: boolean;
  uploadFileName: string;
  uploadError?: string;
  uploadedBy?: string;
  isPrimary?: boolean;
  createdAt?: string;
  progress?: number;
  attachableId?: number;
};

export type useStudyReferenceFilesReturn = {
  refreshError: boolean;
  refreshPage: (referenceId: number) => Promise<void>; // refresh all references in a page that includes a specific reference
  refreshReference: (referenceId: number) => Promise<void>; // only refresh a specific reference
  getFilesForReference: (referenceId: number) => TransformedFile[];
  getRefreshVersionForReference: (referenceId: number) => number;
};

export type oneReferenceUtilitiesReturn = {
  files: TransformedFile[];
  makeFilePrimary: (fileId: string | number) => Promise<void>;
  deleteFile: (file: TransformedFile) => Promise<void>;
};

export type FilesGroupedByRefId = Map<number, TransformedFile[]>;

export const transformFile = (document: Document): TransformedFile => {
  return {
    id: document.id,
    url: document.url,
    uploadFileName: document.upload_file_name,
    uploadedBy: document.uploaded_by,
    isPrimary: document.is_primary,
    createdAt: document.created_at,
    uploadComplete: true,
  };
};
